module.exports = __webpack_public_path__ + "assets/img/zhnygl.e1a1a981.png";